export enum LocalStorageKeys {
    shift = 'shift',
    lang = 'lang',
    hotel_id = 'hotel_id',
    last_event_time = 'last_event_time',
    country = 'country',
    token = 'auth'
}